import React, { FunctionComponent, useEffect, useState } from 'react';
import PageContentComponent from '..';
import { Background } from '../../../types/background';
import { ArrowDownIcon } from '../../Icons';
import './styles.scss';

type ContentGridProps = {
  data: {
    background: Background;
    title?: string | null;
    description?: string | null;
    content: any;
    htmlId: string | null;
  };
}

const ContentGrid: FunctionComponent<ContentGridProps> = ({ data }) => {
  const listSize = 6;
  const [list, setList] = useState([...data.content.slice(0, listSize)]);
  const [loadMore, setLoadMore] = useState(false);
  const [hasMore, setHasMore] = useState(data.content.length > listSize);

  function handleLoadMore() {
    setLoadMore(true);
  }

  useEffect(() => {
    if (hasMore && loadMore) {
      const currentLength = list.length;
      const nextResults = currentLength < data.content.length ? data.content.slice(currentLength, currentLength + listSize) : [];
      setList(prevList => [...prevList, ...nextResults]);
      setLoadMore(false);
    }
  }, [hasMore, loadMore]);

  useEffect(() => {
    const isMore = list.length < data.content.length;
    setHasMore(isMore);
  }, [list]);

  return (
    <section 
      id={data.htmlId || undefined}
      className={`content-grid ${data.background}`}>
      <div>
        {(data.title || data.description) && (
          <div className='content-grid-header'>
            {data.title && (
              <h2>{data.title}</h2>
            )}
            {data.description && (
              <p>{data.description}</p>
            )}
          </div>
        )}
        <div className='content-grid-container'>
          <PageContentComponent content={list} />
        </div>

        {hasMore && (
          <button
            type='button'
            onClick={handleLoadMore}
            className='primary-button'
          >
            Load more
            <ArrowDownIcon />
          </button>
        )}
      </div>
    </section>
  )
}

export default ContentGrid;
